module.exports = __webpack_public_path__ + "images/help/video-kanban-small-efbe0ccb7481ac66927e1921a033a416.png";